module.exports = __webpack_public_path__ + "media/images/samples/members/news-1@2x-fa7f11b5cb2c9895fee8e73e4d4639ca.png";